import { ApiPaths } from 'api/constants';
import {
  GetEndpointsResult,
  TestEndpointParams,
  TmsConnectionDetails,
  TmsEndpointResponse,
  ValidateTmsCredentials,
} from 'api/endpoints/tmsConnections';
import ApiUrlParams from 'constants/apiUrlParams';
import BaseRepo from 'container/BaseRepo';
import { ApiResponseAsync } from 'container/models';

import { ITmsRepo } from './ITmsRepo';

export class TmsRepo extends BaseRepo implements ITmsRepo {
  getConnections = (): ApiResponseAsync<DataWithTotal<TmsConnectionDetails>> =>
    this.helpers.handleGet(ApiPaths.tmsConnections._());

  validateCredentials = (
    connectionParams: ValidateTmsCredentials
  ): ApiResponseAsync<{ valid: boolean }> =>
    this.helpers.handlePost(
      ApiPaths.tmsConnections.validateCredentials._(),
      connectionParams
    );

  addConnection = (
    connectionParams: ValidateTmsCredentials
  ): ApiResponseAsync<TmsConnectionDetails> =>
    this.helpers.handlePost(ApiPaths.tmsConnections._(), connectionParams);

  updateConnection = (
    connection: TmsConnectionDetails,
    updatedParams: ValidateTmsCredentials
  ): ApiResponseAsync<TmsConnectionDetails> =>
    this.helpers.handlePut(
      ApiPaths.tmsConnections.byId._({
        [ApiUrlParams.tmsConnectionId]: connection.id,
      }),
      updatedParams
    );

  deleteConnection = (
    connection: TmsConnectionDetails
  ): ApiResponseAsync<void> =>
    this.helpers.handleDelete(
      ApiPaths.tmsConnections.byId._({
        [ApiUrlParams.tmsConnectionId]: connection.id,
      })
    );

  getEndpoints = (type: string): ApiResponseAsync<GetEndpointsResult> => {
    const params = new URLSearchParams();

    params.set('type', type);

    return this.helpers.handleGet(
      ApiPaths.tmsConnections.endpoints._() + '?' + params.toString(),
      { responseStopTransformPaths: ['endpoints'] }
    );
  };

  testEndpointParams = (
    params: TestEndpointParams
  ): ApiResponseAsync<TmsEndpointResponse> =>
    this.helpers.handlePost(
      ApiPaths.tmsConnections.endpoints.keys._(),
      params,
      { requestStopTransformPaths: ['params'] }
    );
}
